import clsx from 'clsx'

import { DelimitedContent, Icon, Slash } from '@fv/client-components'
import {
  addressFuncs,
  composeStopDetails,
  displayLocShipType,
  militaryToStandardTime,
} from '@fv/client-core'
import type { ShipmentLocation } from '@fv/client-types'

import { CarrierTooltip } from '@/components/CarrierTooltip'
import { DateDisplay } from '@/components/shared/DateDisplay'
import { StopAccessorials } from '@/components/shared/StopAccessorials'

import { RefNumbers } from './RefNumbers'

type StopListProps = {
  bolNum?: string
  locations: ShipmentLocation[]
  showAddress?: boolean
  loadId: string
  booked: boolean
  allowedToEdit?: boolean
}

export const StopList = ({
  bolNum,
  locations,
  showAddress = false,
  loadId,
  booked,
  allowedToEdit = true,
}: StopListProps) => {
  const pickupDate = locations.find(loc => loc.sequence === 0)?.stopDate

  return (
    <>
      {locations.map(x => {
        const refNums = x.refNums?.filter(n => n.value !== bolNum)
        const shipType = displayLocShipType(x)
        const label = [
          x.opensAt ? `Opens at ${militaryToStandardTime(x.opensAt)}` : '',
          x.closesAt ? `Closes at ${militaryToStandardTime(x.closesAt)}` : '',
        ]
          .filter(Boolean)
          .join(' ')
        return (
          <li
            className="general-list__item general-list__date-icon multi-truck-stop-location items-start"
            key={x.sequence}
          >
            <DateDisplay
              className="shipment-item__calendar-icon"
              type={x.type}
              value={x.stopDate}
            />

            <Icon
              className={clsx('flex-none', {
                'text-[#ff9a59]': x.type === 'origin',
                'text-[#99d87a]': x.type === 'destination',
                'text-[#d4d4a3]': x.type === 'stop',
              })}
              icon="map-marker"
              transform="right-3 down-2.5"
            />

            <div className="mb-0 ml-2 flex-1">
              <DelimitedContent delimiter={<Slash />}>
                <CarrierTooltip label={label.trim() || 'Hours not available'}>
                  <span>
                    {' '}
                    {composeStopDetails(x)} at{' '}
                    {showAddress &&
                      addressFuncs.companyAddress(x, {
                        includeLine2: true,
                        dependentOnCompany: false,
                        includeCityStateZip: false,
                      }) + ', '}
                    {addressFuncs.cityStateZip(x)}
                  </span>
                </CarrierTooltip>
                {shipType && <span>{shipType}</span>}
                {!!x.accessorials?.length && (
                  <StopAccessorials
                    pickupDate={pickupDate}
                    location={x}
                    loadId={loadId}
                    allowEditTimes={booked && allowedToEdit}
                  />
                )}
                {!!refNums?.length && <RefNumbers refNums={refNums} />}
              </DelimitedContent>
            </div>
          </li>
        )
      })}
    </>
  )
}
